import { configConstants } from "../constants";
import axios from "axios";
import { history, setHeaders } from "helpers";

export const mylotusServices = {
  updateTransaction,
  addQuotaScratchGame
};

function updateTransaction(params) {
  // Implementation for updating transaction
  var tmp = axios
    .put(
      configConstants.API_BACKEND_CRM + `/reports/transaction-earn`,
      params,
      {
        headers: setHeaders({
          Charset: "utf-8",
          "Content-Type": "application/json"
        })
      }
    )
    .then(response => {
      if (response.data.statusCode.toString() === "200") {
        return {
          status: true,
          data: response.data.data,
          message: response.data.message
        };
      } else if (response.data.message === "UNAUTHORIZE") {
        history.push("/auth/login");
        return {
          status: false,
          data: {},
          message: response.data.message,
          unAlert: true
        };
      } else {
        return {
          status: false,
          data: {},
          message: response.data.message
        };
      }
    });

  return tmp;
}

function addQuotaScratchGame(params) {
  const tmp = axios
    .post(
      configConstants.API_BACKEND_CRM + `/mylotus/games/add-quota/scratchgame`,
      params,
      {
        headers: setHeaders({
          Charset: "utf-8",
          "Content-Type": "application/json"
        })
      }
    )
    .then(response => {
      if (response.data.statusCode.toString() === "200") {
        return {
          status: true,
          data: response.data.data,
          message: response.data.message
        };
      }

      return { status: false, data: {}, message: response.data.message };
    })
    .catch(() => {
      return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
    });

  return tmp;
}
